import React from 'react';
import { Redirect } from 'react-router-dom'; 
const RedirectComponent = () => <Redirect to="/parceiro/projetos/v2" />;

export default RedirectComponent; 
